<template>
  <!-- 用户/职员列表，用于通用的，基础管理列表 -->
  <div class="employee-list-common">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true" page-name="employee" app-name="basedata" v-model="searchInfo">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="用户名称/联系方式" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.roleId" placeholder="请选择角色" clearable>
            <template #prefix>角色名称</template>
            <el-option v-for="role in roleList" :key="role.id" :value="role.id" :label="role.roleName"/>
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="sys:user:save" el-type="success" @click="toShowEdit({})">新建</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false" :show-border="false">
        <separator-page>
          <template #category>
            <tree-dictionary v-if="queryDeparts" :filter="true" v-model:dictionary-list="treeList" dictionary-type="MERCHANT_CATEGORY"
                             label-name="departName"
                             @clickCategory="clickCategory" :query-function="queryDeparts" :save-function="saveDepart"
                             right-add="sys:depart:new" right-edit="sys:depart:save" right-delete="sys:depart:delete"
                             :delete-function="deleteDepart" dialog-label="部门管理">
              <template v-slot:edit="{categoryData}">
                <form-items :data="categoryData" :columns="1" label-width="2.4rem" icon-width=".3rem">
                  <form-item label="部门名称" :required="true" name="dictName">
                    <el-input v-model="categoryData.departName" placeholder="请输入部门名称"/>
                  </form-item>
                  <form-item label="上级部门">
                    <el-tree-select :disabled="!!categoryData.id" v-model="categoryData.parentId" :data="treeList"
                                    default-expand-all check-strictly :render-after-expand="false"
                                    placeholder="请选择上级部门" :props="{children: 'children', label: 'departName'}"
                                    node-key="id"/>
                  </form-item>
                  <form-item label="排序序号">
                    <el-input v-model="categoryData.index" placeholder="请输入排序序号"/>
                  </form-item>
                  <form-item label="联系电话">
                    <el-input v-model="categoryData.leaderPhone" placeholder="请输入联系电话"/>
                  </form-item>
                  <form-item label="负责人">
                    <employee-select v-model="categoryData.leaderId" placeholder="请选择负责人"/>
                  </form-item>
                  <form-item label="职员描述">
                    <el-input v-model="categoryData.desc" type="textarea" :rows="3" placeholder="请输入职员描述"/>
                  </form-item>
                </form-items>
              </template>
            </tree-dictionary>
          </template>
          <table-list>
            <yq-table :data="dataList" height="100%" stripe border page-name="employee" app-name="basedata">
              <yq-table-column label="头像" prop="iconUrl" width="60rem">
                <template v-slot="{row}">
                  <image-show v-model="row.iconUrl" width="1rem" height="1rem"/>
                </template>
              </yq-table-column>
              <yq-table-column label="用户名称" prop="employeeName" :show-overflow-tooltip="true" min-width="100rem">
                <template v-slot="{row}">
                  <!-- 名称渲染的扩展点：默认取本地姓名，业务端有别的口径时可整体覆盖这一格 -->
                  <slot name="employeeName" :row="row">{{ row.employeeName }}</slot>
                </template>
              </yq-table-column>
              <yq-table-column label="联系方式" prop="employeePhone" :show-overflow-tooltip="true" min-width="100rem"/>
              <yq-table-column label="邮件地址" prop="emailAddress" :show-overflow-tooltip="true" min-width="180rem">
                <template v-slot="{row}">
                  <span v-if="row.emailAddress">{{ row.emailAddress }}</span>
                  <span v-else class="muted">—</span>
                </template>
              </yq-table-column>
              <yq-table-column label="部门名称" prop="departName" :show-overflow-tooltip="true">
                <template v-slot="{row}">
                  <el-tag v-for="(it,idx) in row.departList" :key="idx">{{ it.departName }}</el-tag>
                </template>
              </yq-table-column>
              <yq-table-column label="角色名称" prop="roleName" :show-overflow-tooltip="true">
                <template v-slot="{row}">
                  <el-tag v-for="(it,idx) in row.roleList" :key="idx">{{ it.roleName }}</el-tag>
                </template>
              </yq-table-column>
              <yq-table-column label="用户状态" prop="status" width="80rem">
                <template v-slot="{row}">
                  <el-tag v-if="row.status === 1">正常</el-tag>
                  <el-tag type="info" v-else>禁用</el-tag>
                </template>
              </yq-table-column>
              <!--              <yq-table-column label="用户动态" prop="logStatus" :show-overflow-tooltip="true">-->
              <!--                <template v-slot="{row}">-->
              <!--                  <span v-if="row.loginStatus === '0'">离线</span>-->
              <!--                  <span v-else-if="row.loginStatus === '1'">在线(移动端/成都)</span>-->
              <!--                  <span v-else-if="row.loginStatus === '2'">在线(PC端)</span>-->
              <!--                </template>-->
              <!--              </yq-table-column>-->
              <yq-table-column label="最近登录时间" prop="lastLoginTime" :show-overflow-tooltip="true">
                <template v-slot="{row}">{{ row.lastLogin }}</template>
              </yq-table-column>
              <yq-table-column label="最近登录ip" prop="lastIpAddress" :show-overflow-tooltip="true">
                <template v-slot="{row}">{{row.lastIpAddress}}</template>
              </yq-table-column>
              <!-- 业务可追加列表列（如企业微信端要显示「是否已关联企业微信」） -->
              <slot name="columns" :data-list="dataList"/>
              <yq-table-column label="操作" prop="options" :align="'center'" fixed="right"
                               :width="optionsWidth" :show-overflow-tooltip="false">
                <template v-slot="{row}">
                  <!--                  <table-button hasPerm="sys:user:save" v-if="row.status === 0">禁用</table-button>-->
                  <!--                  <table-button hasPerm="sys:user:save" v-else-if="row.status === -1">启用</table-button>-->
                  <table-button-group label="更多">

                    <table-button hasPerm="sys:user:save" @click="toShowEdit(row)">编辑</table-button>
                    <table-button v-if="dataAccessSwitch" hasPerm="sys:user:grant" @click="router.push(`/sys/user/access?id=${row.id}`)">数据权限</table-button>
                    <table-button hasPerm="sys:user:change" @click="$refs.employeeChangeList.showChangeList(row.id)">变更记录</table-button>
                    <table-button hasPerm="sys:user:log" @click="jumpToViewLog(row)">日志记录</table-button>
                    <table-button hasPerm="sys:user:remove" el-type="danger" message="是否确认删除数据"@click="toDeleteMerchant(row)">删除</table-button>
                    <!-- 业务可追加操作按钮，点击后通过 clickRow 事件通知父组件 -->
                    <slot name="options" :row="row"/>

                  </table-button-group>
                </template>
              </yq-table-column>
            </yq-table>
          </table-list>
          <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                     :total-count="searchInfo.totalCount" @onLoad="queryList" :show-border="true"/>
        </separator-page>
      </list-table>
    </list-page>
    <el-dialog dialog-width="2" title="用户信息" v-model="showEditEmployee" :close-on-click-modal="false">
      <dialog-table :auto-height="true">
        <form-items :data="currentEmployee" :columns="2" label-width="2.4rem" icon-width="0">
          <form-item label="登录账号" :required="true" error-message="使用手机号登录" pattern="^1[3-9]\d{9}$"
                     name="employeePhone">
            <el-input v-model="currentEmployee.employeePhone" placeholder="请输入手机号"/>
          </form-item>
          <form-item label="密码">
            <template #title>
              <el-tooltip effect="light" content="如果输入密码，将进行密码重置" placement="bottom">
                <yq-icon name="element-ui_info"/>
              </el-tooltip>
              密码
            </template>
            <el-input type="password" v-model="currentEmployee.password" autocomplete="new-password" placeholder="请输入密码"/>
          </form-item>
          <form-item label="用户名" :required="true" name="employeeName">
            <el-input v-model="currentEmployee.employeeName" placeholder="请输入用户名"/>
          </form-item>
          <!-- 邮件地址可随时修改；不做格式强校验，留空即清空 -->
          <form-item label="邮件地址" desc-message="用于接收系统消息推送的邮件">
            <el-input v-model="currentEmployee.emailAddress" placeholder="请输入邮件地址"/>
          </form-item>
          <form-item label="所属部门">
            <el-tree-select v-model="currentEmployee.departArr" :data="treeList" default-expand-all check-strictly
                            :render-after-expand="false" placeholder="请选择所属部门"
                            :props="{children: 'children', label: 'departName'}" node-key="departCode" multiple/>
          </form-item>
          <form-item label="岗位角色">
            <el-select v-model="currentEmployee.roleIdArr" multiple>
              <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id"/>
            </el-select>
          </form-item>
          <form-item label="用户状态">
            <el-radio-group v-model="currentEmployee.status">
              <el-radio :value="1">启用</el-radio>
              <el-radio :value="0">禁用</el-radio>
            </el-radio-group>
          </form-item>
        </form-items>
        <custom-column page-name="employee" app-name="basedata" v-model="currentEmployee" :columns="2" label-width="2.4rem" icon-width="0"/>
      </dialog-table>
      <template #footer>
        <page-button @click="showEditEmployee = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveEmployee">确定</page-button>
      </template>
    </el-dialog>


    <employee-change-list ref="employeeChangeList"/>

    <!-- 日志记录弹窗 -->
    <el-dialog width="70%" title="日志记录" v-model="showLogDialog" :close-on-click-modal="false">
      <dialog-table>
        <yq-table :data="logList" height="100%" stripe border>
          <yq-table-column label="操作人员" prop="createdName" width="120rem"/>
          <yq-table-column label="操作时间" prop="createdTime" width="180rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="操作内容" prop="accessName" min-width="150rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="IP地址" prop="ipAddress" width="140rem"/>
          <yq-table-column label="操作地点" prop="ipGeoAddress" width="120rem">
            <template v-slot="{row}">
              {{row.ipGeoAddress }}
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="100rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button type="write" @click="toShowLogDetail(row)">查看</table-button>
            </template>
          </yq-table-column>
        </yq-table>
      </dialog-table>
      <form-page v-model:page-number="logSearchInfo.pageNumber" v-model:page-size="logSearchInfo.pageSize"
                 :total-count="logSearchInfo.totalCount" @onLoad="queryLogList">
        提示：默认仅显示近一周的操作日志数据
      </form-page>
      <template #footer>
        <page-button @click="showLogDialog = false" el-type="primary">关闭</page-button>
      </template>
    </el-dialog>

    <!-- 日志详情弹窗 -->
    <el-dialog dialog-width="2" title="操作日志明细" v-model="showLogDetail">
      <dialog-table>
        <form-items label-width="2.4rem" icon-width="0" :columns="2">
          <form-item label="操作人员">{{currentLogData.createdName}}</form-item>
          <form-item label="操作时间">{{currentLogData.createdTime}}</form-item>
          <form-item label="登录ip">{{currentLogData.ipAddress}} / {{currentLogData.ipGeoAddress}}</form-item>
          <form-item label="请求方式">{{ currentLogData.requestMethod }}</form-item>
          <form-item :show-block="true" label="请求参数">
            {{currentLogData.accessArgs}}
          </form-item>
        </form-items>
      </dialog-table>
      <template #footer>
        <page-button @click="showLogDetail = false" el-type="primary">确认</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import TableList from "@/components/h5/layout/ListTable.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import YqIcon from "@/components/YqIcon.vue";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import EmployeeChangeList from "@/views/h5/common/basedata/employee/EmployeeChangeList.vue";
import DynamicData from "@/components/h5/data/DynamicData.vue";
import employeeApi from "@/api/normal/sys/employeeApi";
import systemLogsApi from "@/api/normal/sys/systemLogsApi";
import CustomColumn from "@/components/h5/data/CustomColumn.vue";

export default {
  // 通过queryList触发查询列表，查询的结果，通过setData，将分页查询的结果返回
  emits: ["queryList"],
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EL",
  components: {
    YqIcon,
    PageButton,
    TreeDictionary,
    FormItems,
    FormItem,
    DialogTable,
    ImageShow,
    EmployeeChangeList,
    DynamicData,
    TableList,
    SeparatorPage,
    YqTableColumn,
    TableButtonGroup,
    TableButton,
    SearchCondition,
    FormPage,
    ListTable,
    ListPage,
    EmployeeSelect,
    CustomColumn,
  },
  props: {
    // 操作列宽度。业务往 options 插槽里加按钮后按钮会因为空间不足被隐藏，需要相应加宽
    optionsWidth: {default: "180rem"},
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      treeList: [],
      queryDeparts: null,
      saveDepart: null,
      deleteDepart: null,
      showEditEmployee: false,
      currentEmployee: null,
      roleList: [],
      // 日志相关
      showLogDialog: false,
      showLogDetail: false,
      logList: [],
      logSearchInfo: {},
      currentLogData: {},
      currentUserId: null,
      userInfo: {},
      dataAccessSwitch: false, // 是否开启了权限功能
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    Util.loadPageData(this)// 加载缓存数据失败，初始化页面
    this.resetSearch();
    Util.getUserInfo().then(res => {
      this.userInfo = res;
      // 查询部门
      this.queryDeparts = this.queryDepartList
      this.saveDepart = employeeApi.saveDepart
      this.deleteDepart = employeeApi.deleteDepart
    });
    // 查询角色
    employeeApi.queryAllRoles().then(roles => this.roleList = roles)
    Util.getSystemSettingOptions("DATA_ACCESS_RANGE").then(res => this.dataAccessSwitch = res.length > 0)
  },
  mounted() {
  },
  methods: {
    queryDepartList() {
      return new Promise(resolve => {
        employeeApi.queryDepartList(this.userInfo.merchantId).then(res => {
          resolve(res)
        });
      })
    },
    // 查询员工列表
    queryList() {
      this.$emit("queryList", this.searchInfo); // 触发查询列表事件
    },
    // 父组件，通过setData，将分页查询的结果返回给子组件
    setData(data) {
      this.searchInfo.totalCount = data.totalCount;
      this.dataList = data.records
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async toDeleteMerchant(row) {
      await employeeApi.deleteEmployee(row.id)
      this.resetSearch()
    },
    clickCategory(depart) {
      this.searchInfo.departCode = depart.departCode;
      this.resetSearch()
    },
    toShowEdit(data) {
      if (Object.keys(data).length > 0) {
        data.roleIdArr = data.roleList.map(item => item.id)
        data.departArr = data.departList.map(item => item.departCode)
        this.currentEmployee = {...data, password: ""};
      } else {
        this.currentEmployee = {}
      }
      this.showEditEmployee = true;
    },
    async saveEmployee() {
      await employeeApi.save(this.currentEmployee)
      this.showEditEmployee = false;
      this.resetSearch();
    },
    // 跳转查看日志
    jumpToViewLog(row) {
      this.logSearchInfo = {
        pageNumber: 1,
        pageSize: 10,
        dataId: row.id
      };
      this.showLogDialog = true;
      // 开始时间和结束时间，默认查询一周内的数据
      this.logSearchInfo.endTime = new Date().format("yyyy-MM-dd") + " 00:00:00";
      // 今天是周几
      let day = new Date().getDay();
      if (day === 0) {
        day = 7;
      }
      // 获取周一
      this.logSearchInfo.startTime = new Date(new Date().getTime() - (day - 1) * 24 * 3600 * 1000).format("yyyy-MM-dd") + " 23:59:59";
      this.queryLogList();
    },

    // 查询日志列表
    async queryLogList() {
      const res = await systemLogsApi.queryList(this.logSearchInfo);
      let list = res.records;
      for (let i = 0; i < list.length; i++) {
        this.geoIpAddress(list[i]);
      }
      this.logList = list;
      this.logSearchInfo.totalCount = res.totalCount;
    },

    // 查看日志详情
    async toShowLogDetail(data) {
      const res = await systemLogsApi.findById(data.id);
      this.geoIpAddress(res);
      this.currentLogData = res;
      this.showLogDetail = true;
    },

    // 更新实际地址
    geoIpAddress(data) {
      // 实际地址
      data.ipGeoAddress = data.ipAddress !== '' && (data.ipAddress.startsWith("192.168") || data.ipAddress.startsWith("172.") || data.ipAddress.startsWith("10.")) ? '本地内网' : data.ipGeoAddress;
    }
  }
}
</script>

<style lang="scss" scoped>
.employee-list-common{
  height: 100%;
}
// 空值占位（如未填写的邮件地址）
.muted {
  color: #909399;
}
.el-tag {
  margin-right: 10px;

  &:last-child {
    margin-left: 0;
  }
}

.dialog-tips {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  background-color: #f4f4f5;
  border-left: 4px solid #409eff;
  color: #606266;
  font-size: 14px;
  border-radius: 4px;

  .el-icon {
    color: #409eff;
    font-size: 16px;
  }

  span {
    line-height: 1.5;
  }
}
</style>